var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoResultsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "140.4%",
    height: "140.4%",
    x: "-20.2%",
    y: "-20.2%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#CFD6DA"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    filter: "url(#a)",
    transform: "translate(24 24)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M37.143 32.686h-2.377l-.892-.892c2.972-3.268 4.755-7.725 4.755-12.48A19.276 19.276 0 0 0 19.314 0 19.276 19.276 0 0 0 0 19.314 19.276 19.276 0 0 0 19.314 38.63c4.755 0 9.212-1.783 12.48-4.755l.892.892v2.377L47.543 52 52 47.543zm-17.829.712A14.025 14.025 0 0 1 5.231 19.314c0-7.824 6.26-14.083 14.083-14.083s14.084 6.26 14.084 14.083-6.26 14.084-14.084 14.084"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.26 27.266-5.008-5.01-5.009 5.01-3.005-3.006 5.009-5.008-5.01-5.009 3.006-3.005 5.01 5.009 5.007-5.01 3.006 3.006-5.009 5.009 5.009 5.008z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResultsIcon);
export default __webpack_public_path__ + "static/media/noResultsIcon.6ef16c8b696588ab4a36d0b6088e8c93.svg";
export { ForwardRef as ReactComponent };